/**
 * Represents a card template, extending the backend card template.
 * This class is used to create card templates for the frontend.
 */
import { CardTemplate as BackendCardTemplate } from '@longtail-education/superprep-data-model-frontend'

export class CardTemplate extends BackendCardTemplate {
  // The unique identifier of the card template.
  declare readonly id: string

  /**
   * Creates an instance of CardTemplate.
   * @param options An object containing the properties of the card template.
   */
  constructor(options: CardTemplate) {
    if (!options.id) throw new Error('Card template id is required');
    // Calls the constructor of the superclass (BackendCardTemplate) with the provided options.
    super(
      options.id,
      options.moduleId,
      options.submoduleId,
      options.elementId,
      options.siblingId,
      options.cardQuestion,
      options.cardAnswer,
      options.gameplayInfo,
      options.conceptInfo,
      options.spacedRepInfo,
      options.diagram
    )
    this.random = options.random
  }
}
